import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=50fd18b6&scoped=true&"
import script from "./RoleManagement.vue?vue&type=script&lang=ts&"
export * from "./RoleManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=50fd18b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd18b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VHover,VIcon,VRow})
